import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="bg-delux-alt py-20 px-4 sm:px-6 lg:px-8 border-y border-delux-gold/10" data-id="element-227">
      <div className="max-w-4xl mx-auto" data-id="element-228">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center text-center mb-12" data-id="element-229">
          <div className="w-16 h-16 rounded-full bg-delux-gold/10 flex items-center justify-center mb-6" data-id="element-230">
            <AlertTriangleIcon className="w-8 h-8 text-delux-gold" data-id="element-231" />
          </div>
          <h2 className="font-heading text-3xl md:text-4xl text-delux-gold mb-8" data-id="element-232">
            Lo Que Nadie En La Industria De Las Barberías Quiere Admitir
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="font-body text-lg text-delux-body leading-relaxed space-y-6 bg-delux-card p-8 md:p-12 rounded-lg border border-delux-gold/20 shadow-2xl" data-id="element-233">
          <p className="text-xl text-delux-white font-medium" data-id="element-234">
            La mayoría de las barberías están diseñadas para el volumen, no para
            ti.
          </p>

          <p className="font-heading text-2xl text-delux-gold/80 italic" data-id="element-235">
            Entran. Salen. Cobran. Repiten.
          </p>

          <p data-id="element-236">
            No hay estudio de tu estructura facial. No hay conversación sobre tu
            estilo de vida y hacia dónde vas. No hay atención en si el fade
            realmente complementa tu forma de cara, tu barba, tu estilo
            personal.
          </p>

          <p data-id="element-237">Solo — el siguiente.</p>

          <p data-id="element-238">
            Y lo peor: lo has aceptado. Porque en Lehigh Acres, asumiste que así
            son las cosas.
          </p>

          <p className="text-delux-gold font-heading text-2xl pt-4" data-id="element-239">
            No tiene que ser así.
          </p>
        </motion.div>
      </div>
    </section>;
}